import { render, staticRenderFns } from "./table-shipping-message.vue?vue&type=template&id=126ac6a1&"
import script from "./table-shipping-message.vue?vue&type=script&lang=js&"
export * from "./table-shipping-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports